import { ENVIRONMENT } from '@/constants/appConstants'
import { ConfigContext } from '@/providers/config-provider'
import { isRunningClientSide } from '@lib-helpers'
import { ReactElement, ReactNode, use } from 'react'

const environmentIsProduction = (envVariables: { [key: string]: string | undefined }) => {
    const isDev = envVariables?.NEXT_PUBLIC_IS_DEVELOPMENT?.toLowerCase() === 'true'
    const isNonProd = !!envVariables?.NEXT_PUBLIC_ENVIRONMENT
        ? [ENVIRONMENT.test, ENVIRONMENT.acc, ENVIRONMENT.migr].includes(envVariables?.NEXT_PUBLIC_ENVIRONMENT)
        : false
    const isProd: boolean = !isDev && !isNonProd

    return isProd
}

const isProduction = (): boolean | null => {
    if (isRunningClientSide()) {
        const config = use(ConfigContext)
        if (!config?.envVariables) return null

        const { envVariables } = config

        return !!environmentIsProduction(envVariables)
    }

    return !!environmentIsProduction(process.env)
}

interface Props {
    children: ReactNode
    isNotProduction?: boolean
    isProduction?: boolean
}

/**
 * Hides children when:
 * - isNotProduction == true and environment is not production
 * - isProduction == true and environment is production
 * - couldn't determine environment
 */
export const HiddenWhenEnvironment = ({
    isNotProduction: hideWhenNotOnProduction,
    isProduction: hideOnProduction,
    children,
}: Props): ReactElement => {
    const envIsProduction = isProduction()
    let visuallyHidden = false
    if (envIsProduction === null) visuallyHidden = true
    if (hideWhenNotOnProduction && !envIsProduction) visuallyHidden = true
    if (hideOnProduction && envIsProduction) visuallyHidden = true
    return <div className={visuallyHidden ? 'hidden' : ''}>{children}</div>
}
